;(function($, window, document, undefined) {

	var appId = "com_baseballcard";
	var pluginName = "symbolPreview";

	var defaults = {
		placement : "right",
		delay : {
			show : 500,
			hide : 250
		},
		symbol: null,
		showEvent: "mouseenter",
		hideEvent: "mouseleave",
		onShow : function() {},
		onHide: function () { },
		ListId: null
	};

	// ----------------------------------------------------------------------------------------------------------------
	// Class definition
	// ----------------------------------------------------------------------------------------------------------------

	function SymbolPreview(element, options) {
		this.element = element;
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);

		// Handle when "delay" is not an obj
		if (!isNaN(this.options.delay)) {
			var globalDelay = this.options.delay;

			this.options.delay = {
				show : globalDelay,
				hide : globalDelay
			};
		}

		this.init();
	}

	SymbolPreview.prototype = {

		init : function() {
			var self = this;
			
			// Remove any existing instances
			var $existing = $("#widget-com_baseballcard").parent();
			this.dispose($existing);

			this.$element.tooltip({
				maxWidth: 600,
				placement: this.options.placement,
				delay: this.options.delay,
				distance: 0,
				padding: 0,
				pauseOnHover: true,
				arrow: false,
				showEvent: this.options.showEvent,
				hideEvent: this.options.hideEvent,
				onShow: function() {},
				onHide: function() {
					// Remove the app instances
					self.dispose(self.$floater);

					self.options.onHide();
				},
				onEnter: function(tip) {
					self.$floater = tip.$floater;
					self.query = self.load(appId, self.options.symbol, tip.$floater, function() {
						self.options.onShow();
						self.initter();
					});
				},
				onLeave: function() {
					if (self.query) {
						self.query.abort();
					}
				}
			});
		},

		dispose: function($el) {
			// Remove the app instances
			if ($el != null && $el.length > 0) {
				$el.find("div.widget").each(function (i, widget) {
					var instances = $(widget).data("widget");

					if (instances) {
						instances.dispose();
					}
				});
			}
		},

		$floater: null,

		// Function responsible for init'ing the module
		initter: function() {},

		abort: function() {
			if (this.query) {
				this.query.abort();
			}

			this.dispose(this.$floater);
			if (this.$floater != null && this.$floater.length > 0) {
				this.$floater.empty().remove();
			}
		},

		load: function(appId, symbol, container, callback) {
			var self = this;

			container.empty();

			return mod.modules.widgetapi.load({
				widgets: {
					appId: appId,
					context: {
						Symbol: symbol,
						ListId: self.options.ListId
					}
				},
				success: function(response, inlineFn) {
					self.initter = inlineFn;

					if (response.apps && response.apps.length) {
						self.$element.attr("data-title", response.apps[0].html);
					}

					if (callback) {
						callback();
					}
				},
				container: container,
				disableInlines: true
			});
		}

	};

	// ----------------------------------------------------------------------------------------------------------------
	// Plugin api
	// ----------------------------------------------------------------------------------------------------------------

	$.fn[pluginName] = function(options) {
		var instance = this.data("plugin_" + pluginName);

		if (options === "abort") {
			if (instance) {
				instance.abort();
			}
		}
		else {
			return this.each(function() {
				if (!$.data(this, "plugin_" + pluginName)) {
					$.data(this, "plugin_" + pluginName, new SymbolPreview(this, options));
				}
			});
		}
	};

})(jQuery, window, document);